import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  name: 'María',
  age: '32 años',
  quote: 'No sabía qué darle de comer y me daba miedo hacerlo mal. Siempre dudaba si lo estaba alimentando bien. En pocos días de aplicar el ebook, mi perro empezó a tener más energía y mejor digestión. Hoy lo veo mucho más feliz.',
  initial: 'M',
  color: 'bg-pink-100 text-pink-700',
  image: 'https://cdn.magicpatterns.com/uploads/7FbBYyt4zELbsyv4KguGza/WhatsApp_Image_2026-03-25_at_15.21.56.jpg'
}, {
  name: 'Sofía',
  age: '28 años',
  quote: 'Pensé que era complicado, pero es súper fácil de seguir. Ahora sé exactamente qué darle y en qué cantidad. Me dio mucha tranquilidad.',
  initial: 'S',
  color: 'bg-purple-100 text-purple-700',
  image: 'https://cdn.magicpatterns.com/uploads/6tKU6m6Vur3BPYf25YHQwJ/FBISHjERK_mid.jpg'
}, {
  name: 'Lucía',
  age: '35 años',
  quote: 'Ahora preparo la comida para toda la semana en un solo día y me ahorro un montón de tiempo. Super práctico.',
  initial: 'L',
  color: 'bg-blue-100 text-blue-700',
  image: 'https://cdn.magicpatterns.com/uploads/baRdTmxWLcGyoyvA38SQ27/IMG_4179.png'
}, {
  name: 'Carla',
  age: '41 años',
  quote: 'Gastaba muchísimo en alimento de marca y no veía resultados. Con este ebook aprendí a hacer comidas naturales más económicas y mucho más saludables. Ahorro dinero y mi perro está mejor que nunca.',
  initial: 'C',
  color: 'bg-green-100 text-green-700'
}, {
  name: 'Valentina',
  age: '30 años',
  quote: 'Fue un antes y un después. Pasé de no saber qué darle a tener todo claro. Mi perro tiene más energía, mejor pelo y está mucho más activo.',
  initial: 'V',
  color: 'bg-orange-100 text-orange-700'
}, {
  name: 'Justina',
  age: '25 años',
  quote: 'En 7 días ya vi el cambio.',
  initial: 'J',
  color: 'bg-teal-100 text-teal-700'
}, {
  name: 'Laura',
  age: '37 años',
  quote: 'Le encantó a mi perrito gracias',
  initial: 'L',
  color: 'bg-rose-100 text-rose-700',
  image: 'https://cdn.magicpatterns.com/uploads/nzAF2sq4muVqdKGtqcqMbg/DKZbbA9nZ_mid.jpg'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-cream" data-id="element-262">
      <div className="max-w-6xl mx-auto" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-264">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4 font-serif" data-id="element-265">
            Más de 2.000 dueños ya mejoraron la alimentación de sus mascotas
          </h2>
          <div className="flex justify-center items-center gap-3 mb-4" data-id="element-266">
            <div className="flex" data-id="element-267">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-accent text-accent" data-id="element-268" />)}
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-269">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-sage flex flex-col h-full" data-id="element-270">
              {testimonial.image && <div className="mb-5 flex justify-center" data-id="element-271">
                  <img src={testimonial.image} alt={`Foto de ${testimonial.name}`} className="max-w-[60%] h-auto object-contain rounded-xl" data-id="element-272" />
                </div>}

              <p className="flex items-center flex-wrap gap-x-1.5 text-sm text-charcoal mb-2" data-id="element-273">
                <span className="font-bold" data-id="element-274">{testimonial.name}</span>
                <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-emerald-600" data-id="element-275">
                  <BadgeCheckIcon className="w-3.5 h-3.5 fill-emerald-600 text-white" data-id="element-276" />
                  Verificada
                </span>
                <span className="text-gray-400" data-id="element-277">·</span>
                <span className="text-gray-400 font-normal" data-id="element-278">
                  {testimonial.age}
                </span>
              </p>

              <div className="flex mb-3" data-id="element-279">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-accent text-accent" data-id="element-280" />)}
              </div>

              <p className="text-gray-700 italic flex-1 text-lg" data-id="element-281">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}